<template>
  <form @submit.prevent="submit" class="form-horizontal">
    <div class="panel panel-default">
      <div class="panel-body">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            :error="(errors.name || [])[0]"
        />

        <TextFormGroup
            v-model="data.title"
            name="title"
            label="Title"
            :error="(errors.title || [])[0]"
        />

        <TextFormGroup
            v-model="data.email"
            name="email"
            label="Email"
            :error="(errors.email || [])[0]"
        />

        <TextFormGroup
            v-model="data.phone"
            name="phone"
            label="Phone"
            :error="(errors.phone || [])[0]"
        />

        <GalleryFormGroup
            v-model="data.image_id"
            name="image_id"
            label="Image"
            :error="(errors.image_id || [])[0]"
        />

        <hr>

        <SubmitFormGroup button-class="btn-black"/>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import HelpText from '@/components/HelpText'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    GalleryFormGroup,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  props: {
    portalCompany: {
      required: true
    }
  },

  data() {
    return {
      data: {},
    }
  },

  methods: {
    submit() {
      http.post('/api/v2/contacts', {...this.data, portal_company_id: this.portalCompany.id})
          .then(() => {
            notify.success('The contact was saved')

            this.$router.push('.')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
